

import AppEventBus from "../../utils/AppEventBus";
import XModal from "./XModal.vue";
import InputText from "primevue/inputtext";
import {xConfirmProps, xInputType, xNotifyProps, xPromptProps, xShowModalProps} from "../../utils/xapi";
import Editor from "primevue/editor";


export default {
    components: {XModal, InputText, Editor},
    data() {
        return {
            modalInfoContent: '',
            modalInfoHeader: '',

            showHideBtn: true,
            showOkBtn: true,
            showCancelBtn: true,

            onSuccess: null,
            onCancel: null,

            showInputText: false,
            showInputTextArea: false,

            showOverlay: false,

            iconType: null,

            inputTextPlaceholder: null,
            inputTextValue: null,

            okBtnText: null,
            cancelBtnText: null,

            resolver: null,

        }
    },
    methods: {

        async onHide() {

            this.iconType = null;
            this.onSuccess = undefined;

            if (this.onCancel)
                await this.onCancel();

            this.onCancel = undefined;

        },

        async success() {

            if (this.resolver)
                await this.resolver({result: 'success', data: this.inputTextValue})

            if (this.onSuccess)
                await this.onSuccess(this.inputTextValue);

            await this.$refs.XModal.hide();

        },

        async cancel() {

            if (this.resolver)
                await this.resolver({result: 'cancel'})

            if (this.onCancel)
                await this.onCancel();

            await this.$refs.XModal.hide();
        },

        xError($text, $header = 'Ошибка') {

            this.showHideBtn = true
            this.showOkBtn = false
            this.showCancelBtn = false

            this.modalInfoHeader = $header;
            this.modalInfoContent = $text;
            this.$refs.XModal.show();

        },

        xnotify($options: string | xNotifyProps) {

            if (typeof $options === 'object') {
                this.$toast.add({
                    severity: $options.type ?? 'success',
                    summary: $options.header ?? 'Оповещение',
                    detail: $options.text ?? $options,
                    life: $options.timeout ?? 3000
                });
            } else {
                this.$toast.add({severity: 'success', summary: 'Оповещение', detail: $options, life: 3000});
            }

        },
        xerror($text) {
            this.$toast.add({severity: 'error', summary: 'Ошибка', detail: $text, life: 10000});
        },
        xShowModalError($data: xShowModalProps | string) {

            this.showHideBtn = (typeof $data === 'object' && $data?.showHideBtn) ? $data?.showHideBtn : true
            this.showOkBtn = (typeof $data === 'object' && $data?.showOkBtn) ? $data?.showOkBtn : false
            this.showCancelBtn = (typeof $data === 'object' && $data?.showCancelBtn) ? $data?.showCancelBtn : false
            this.iconType = 'error';

            this.hideInput();
            this.showOverlay = true;

            if (typeof $data === 'object') {

                this.modalInfoHeader = $data.header ?? 'Ошибка';
                this.modalInfoContent = $data.text;
                this.iconType = $data.icon ?? 'error';

            } else if (typeof $data === 'string') {

                this.modalInfoHeader = 'Ошибка';
                this.modalInfoContent = $data;

            }

            this.onSuccess = null;

            this.$refs.XModal.show();
        },
        xShowModal(options: xShowModalProps) {

            this.showHideBtn = options?.showHideBtn ?? true
            this.showOkBtn = options?.showOkBtn ?? false
            this.showCancelBtn = options?.showCancelBtn ?? false

            this.hideInput();
            this.iconType = options.icon ?? null;
            this.showOverlay = options.overlay;
            this.modalInfoHeader = options?.header ?? 'Информация';
            this.modalInfoContent = options?.text;
            this.$refs.XModal.show();

        },
        xConfirm(options: xConfirmProps) {

            this.showHideBtn = options?.showHideBtn ?? false
            this.showOkBtn = options?.showOkBtn ?? true
            this.showCancelBtn = options?.showCancelBtn ?? true

            this.setButtonsText(options);
            this.hideInput();
            this.iconType = options.icon ?? 'warning';
            this.modalInfoHeader = options.header ?? 'Подтвердите';
            this.modalInfoContent = options.text;
            this.onSuccess = options.onSuccess;
            this.onCancel = options.onCancel;
            this.showOverlay = options.overlay;
            this.$refs.XModal.show();
            this.resolver = options?.resolver

        },
        async xPrompt(options: xPromptProps) {

            this.showHideBtn = options?.showHideBtn ?? false
            this.showOkBtn = options?.showOkBtn ?? true
            this.showCancelBtn = options?.showCancelBtn ?? true

            this.setButtonsText(options);
            this.showInput(options?.inputType);
            this.iconType = options.icon ?? null;
            this.modalInfoHeader = options.header ?? 'Подтвердите';
            this.modalInfoContent = options.text;
            this.onSuccess = options.onSuccess;
            this.onCancel = options.onCancel;
            this.showOverlay = options.overlay;

            this.inputTextValue = options.defaultValue;
            this.inputTextPlaceholder = options.inputPlaceholder;

            await this.$refs.XModal.show();

            if (options?.inputType === 'input') {
                this.$refs.InputText.$el.focus()
            }


        },

        hideInput() {
            this.showInputText = false;
            this.showInputTextArea = false;
            this.inputTextValue = '';
            this.inputTextPlaceholder = null;
        },

        showInput(inputType?: xInputType) {

            if (inputType === 'textarea') {
                this.showInputTextArea = true;
                this.showInputText = false;
            } else {
                this.showInputTextArea = false;
                this.showInputText = true;
            }

        },
        setButtonsText(options: xShowModalProps) {

            this.okBtnText = options.okBtnText ?? 'Да';
            this.cancelBtnText = options.cancelBtnText ?? 'Нет';

        }

    },
    mounted() {

        AppEventBus.on('xnotify', this.xnotify);
        AppEventBus.on('xerror', this.xerror);
        AppEventBus.on('xShowModalError', this.xShowModalError);
        AppEventBus.on('xShowModal', this.xShowModal);
        AppEventBus.on('xConfirm', this.xConfirm);
        AppEventBus.on('xPrompt', this.xPrompt);

    },
    unmounted() {

        AppEventBus.off('xnotify', this.xnotify);
        AppEventBus.off('xnotify', this.xerror);
        AppEventBus.off('xShowModalError', this.xShowModalError);
        AppEventBus.off('xShowModal', this.xShowModal);
        AppEventBus.off('xConfirm', this.xConfirm);
        AppEventBus.off('xPrompt', this.xPrompt);
    }


}

